module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8bcd83eb9f0ebad59295f94c2dd7b3b6.png";